import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { ControlledInput } from "../../../../components/controlled-input";
import { ModalTransferToUser } from "../../../../components/modal-transfer-to-user";
import { useCreateAgencySaleDetail } from "../../../../hooks/agencies-sales-details/use-create-agency-sale-detail";
import { AGENCY_FIRST_QUERY_KEY } from "../../../../hooks/agencies/use-get-agency-first";
import { useGetMyProfile } from "../../../../hooks/profile/use-get-my-profile";
import {
  UserAction,
  UserActionReturn,
  USERS_ACTIONS,
} from "../../../../hooks/subscription/types";
import { useSub } from "../../../../hooks/subscription/use-sub";
import { InfoCoins } from "./components/info-coins";

const schema = z.object({
  id: z.string(),
  amount: z.string(),
});

type FormData = z.infer<typeof schema>;

export const CoinsTransferArea = () => {
  const queryClient = useQueryClient();

  const [paymentType, setPaymentType] = useState<"user" | "agent" | null>(null);
  const [info, setInfo] = useState<FormData | null>(null);
  const [isModalConfirmVisible, setIsModalConfirmVisible] = useState(false);

  const { user, invalidate } = useGetMyProfile();
  const { create } = useCreateAgencySaleDetail();

  const form = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  const coins = user?.agency?.coinsForSale;

  const handleSubmit = form.handleSubmit(async (data) => {
    if (!user?.id) {
      return;
    }

    if (parseFloat(data?.amount) > (coins ?? 0)) {
      return alert("not allowed");
    }

    create({
      agencyId: user?.id,
      coins: parseFloat(data?.amount),
      userId: Number(data?.id),
      isAgency: paymentType === "agent",
    });

    setIsModalConfirmVisible(false);

    form.setValue("id", "", {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    form.setValue("amount", "", {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  });

  const fields = form.formState.dirtyFields;
  const isDirty = Object.keys(fields).length > 0;

  const disabled = !isDirty || !paymentType;

  const handleSelect = (type: "user" | "agent") => {
    setPaymentType(type);
  };

  const boxStyle = (type: "user" | "agent") => ({
    flex: 1,
    padding: "15px",
    border: `2px solid ${paymentType === type ? "#2196f3" : "#ccc"}`,
    borderRadius: "8px",
    textAlign: "center" as const,
    cursor: "pointer",
    background: "#fff",
    transition: "border-color 0.2s",
  });

  useSub<UserActionReturn>({
    endpoint: `${USERS_ACTIONS}/${user?.id}`,
    skip: !user?.id,
    onData: (data) => {
      console.log("chegou");
      if (data?.action === UserAction.updateBalance) {
        invalidate();

        queryClient.invalidateQueries({
          queryKey: [AGENCY_FIRST_QUERY_KEY],
          exact: false,
        });
      }

      if (data?.action === UserAction.updateAgencyBalance) {
        invalidate();

        queryClient.invalidateQueries({
          queryKey: [AGENCY_FIRST_QUERY_KEY],
          exact: false,
        });
      }
    },
  });

  return (
    <div style={{ background: "#f0f3fc", padding: "20px" }}>
      <div
        style={{ background: "#fff", padding: "20px", borderRadius: "10px" }}
      >
        <InfoCoins />

        <ControlledInput
          control={form.control}
          name="id"
          label="* Transfer To"
          type="number"
          placeholder="ID"
        />

        <ControlledInput
          control={form.control}
          name="amount"
          label="* Transfer Amount"
          type="number"
          placeholder="Please enter coins amount"
        />

        <label
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            display: "block",
            marginBottom: "10px",
          }}
        >
          * To His/Her
        </label>

        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <div style={boxStyle("user")} onClick={() => handleSelect("user")}>
            <span
              style={{
                background: "#2196f3",
                color: "#fff",
                padding: "4px 8px",
                borderRadius: "12px",
              }}
            >
              User
            </span>

            <div style={{ marginTop: "5px", fontSize: "14px" }}>
              Coins account
            </div>
          </div>

          <div style={boxStyle("agent")} onClick={() => handleSelect("agent")}>
            <span
              style={{
                background: "#ff4081",
                color: "#fff",
                padding: "4px 8px",
                borderRadius: "12px",
              }}
            >
              Agent
            </span>

            <div style={{ marginTop: "5px", fontSize: "14px" }}>
              Agent account
            </div>
          </div>
        </div>

        <small style={{ color: "#777" }}>
          (Coins account is only for consumption)
        </small>

        <ModalTransferToUser
          typePayment={paymentType}
          visible={isModalConfirmVisible}
          info={info}
          handleSubmit={handleSubmit}
          handleCloseModal={() => setIsModalConfirmVisible(false)}
        >
          <button
            disabled={disabled}
            onClick={() => {
              setIsModalConfirmVisible(true);
              setInfo(form.getValues());
            }}
            style={{
              background: !disabled ? "#3f51b5" : "#bbbaba",
              width: "100%",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "8px",
              marginTop: "20px",
            }}
          >
            Transfer
          </button>
        </ModalTransferToUser>
      </div>
    </div>
  );
};
